<template>
	<section class="view-pad-coach-marks">
		<ChalkyUiCoachMarkSequencer id="tipPadTutorial" v-bind:arrow="true" v-bind:steps="steps" />
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * Coach mark definitions for onboarding users to the pad creator
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Pad
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewPadCoachMarks extends ViewBase {
		/**
		 * Whether to include the Play button coach mark step
		 *
		 * @type boolean
		 */
		@Prop({ default: false })
		public showPlayButton!: boolean;

		/**
		 * Computed list of coach mark steps, conditionally including
		 * the Play step based on the showPlayButton prop
		 *
		 * @type any[]
		 */
		protected get steps(): any[] {
			const allSteps = [
				{
					content: 'Creates a fresh, randomized layout.',
					placement: 'right',
					position: 'center',
					target: '#btnPadShuffle',
					theme: 'light',
					title: 'Shuffle Rack',
				},
				{
					content: 'Reset to an empty table.',
					placement: 'right',
					position: 'bottom',
					target: '#btnPadClear',
					theme: 'light',
					title: 'Clear Rack',
				},
				{
					content: 'Practice this layout in Trainer mode.',
					placement: 'right',
					position: 'bottom',
					target: '#btnPadPlay',
					theme: 'light',
					title: 'Shoot the Rack',
				},
				{
					content: 'Swap the selected ball with one from the tray.',
					placement: 'top',
					position: 'center',
					target: '.view-balltray',
					theme: 'light',
					title: 'Select Balls',
				},
				{
					content: 'Take a quick tour of the Pad.',
					placement: 'left',
					position: 'bottom',
					target: '#btnPadTutorial',
					theme: 'light',
					title: 'Learn More',
				},
			];

			// Filter out the Play step if the trainer feature is not available
			if (!this.showPlayButton) {
				return allSteps.filter((step) => step.target !== '#btnPadPlay');
			}

			return allSteps;
		}
	}
</script>
